import React, { useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function VerifyBanner() {
  const [show, setShow] = useState(false);
  const [resent, setResent] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("oryyn_token");
    let saved = null;
    try {
      saved = JSON.parse(localStorage.getItem("oryyn_user") || "null");
    } catch {
      saved = null;
    }
    if (!token || !saved) return;

    // Show immediately if we already know they're unverified…
    if (saved.is_verified === false) setShow(true);

    // …and refresh from the server to catch verifications done elsewhere.
    axios
      .get(`${API_URL}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        const verified = res.data?.is_verified;
        try {
          const u = JSON.parse(localStorage.getItem("oryyn_user") || "null");
          if (u) {
            u.is_verified = verified;
            localStorage.setItem("oryyn_user", JSON.stringify(u));
          }
        } catch {
          /* ignore */
        }
        setShow(verified === false);
      })
      .catch(() => {});
  }, []);

  const resend = async () => {
    setResent("sending");
    try {
      const token = localStorage.getItem("oryyn_token");
      await axios.post(
        `${API_URL}/auth/resend-verification`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setResent("sent");
    } catch {
      setResent("error");
    }
  };

  if (!show) return null;

  return (
    <div className="verify-banner" role="status">
      <span className="verify-banner-icon">✉️</span>
      <span className="verify-banner-text">
        Please verify your email to secure your account.
      </span>
      {resent === "sent" ? (
        <span className="verify-banner-sent">Sent — check your inbox</span>
      ) : (
        <button
          className="verify-banner-btn"
          onClick={resend}
          disabled={resent === "sending"}
          type="button"
        >
          {resent === "sending" ? "Sending…" : resent === "error" ? "Try again" : "Resend"}
        </button>
      )}
      <button
        className="verify-banner-close"
        onClick={() => setShow(false)}
        type="button"
        aria-label="Dismiss"
      >
        ✕
      </button>
    </div>
  );
}
